export default __webpack_public_path__ + "locales/bg/ArchiveDialog.json?hash=7aa62e0e6f1546fadb4c5beb28491909";